import React from "react";
import "./webReport.css";
import Title from "../../components/Title";
import HazardIcon from "../../images/hazard.svg";
import RecommendationIcon from "../../images/recommendation.svg";
import MaintenanceIcon from "../../images/maintenance.svg";
import InfoIcon from "../../images/info.svg";
import LimitIcon from "../../images/limit.svg";

const definitions = [
  {
    icon: HazardIcon,
    label: "Safety Hazard",
    badgeStyles: "safety-hazard",
    description:
      "Indicates a condition that presents a potential threat to health or safety. These issues should receive immediate attention or professional repair.",
  },
  {
    icon: RecommendationIcon,
    label: "Recommendation",
    badgeStyles: "recommendation",
    description:
      "Represents items that require correction or further evaluation to prevent future failure or costly damage.",
  },
  {
    icon: MaintenanceIcon,
    label: "Maintenance",
    badgeStyles: "maintenance",
    description:
      "Refers to routine care or preventive maintenance actions that help preserve system performance and longevity.",
  },
  {
    icon: InfoIcon,
    label: "Info",
    badgeStyles: "info",
    description:
      "Provides general observations or reference notes about the property that do not indicate a defect or concern.",
  },
  {
    icon: LimitIcon,
    label: "Limit",
    badgeStyles: "limit",
    description:
      "Indicates areas or components that could not be inspected or were partially inaccessible at the time of inspection.",
  },
];

const DefinitionsGlossary = ({ sectionNumber }) => {
  return (
    <div className="metadata-container" id="definitions-glossary">
      <Title text="Definitions & Glossary" sectionNumber={sectionNumber} />
      <div className="definitions-glossary-content">
        {definitions.map((item, index) => (
          <div key={index} className="definition-row">
            <div className="definition-label-container">
              <img
                src={item.icon}
                alt={item.label}
                className="definition-icon"
              />
              <span
                className={`definition-label concerning-level-${item.badgeStyles}`}
              >
                {item.label}
              </span>
            </div>
            <p className="definition-description">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefinitionsGlossary;
